function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m179.7 24-47.5-23.1h-3.3v26.7h3.2v-23.3l47.5 23.3h3.3v-26.7h-3.2z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m191.2.9v2.9h25v23.8h3.2v-23.8h24.9v-2.9z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m116.8 27.6h4.5l-30.4-27.6-30.4 27.6h4.5l8.1-7.1h35.5zm-40.6-10 14.7-13.3 14.7 13.2h-29.4z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m24.7 13.2v2.9h26.8v5.7c-4.6 2.1-11.4 3.7-21.4 3.7-12 0-26.3-3.7-26.3-11.4s14.6-11.1 25.6-11.1c9.7 0 17.6 2.1 22.2 4.7l1.9-2.6c-4.8-2.6-13.1-5-24-5-13.6 0-29.5 4.8-29.5 14 0 9.3 15.7 14.2 30.1 14.2 10 0 18.2-1.6 24.8-4.8v-10.2-.1z"
});

var SvgGant = function SvgGant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.3 28.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "gant.svg";
export { ForwardRef as ReactComponent };